import React, { useState } from 'react';
import { Paper, Tab, Tabs } from '@material-ui/core';

import { UploadDriverTipsSettings } from 'components/product/components/uploadDriverTipsSettings';
import { ViewDriverTipsSettings } from 'components/product/components/viewDriverTipsSettings';
import { Notifications, TabPanel } from 'shared';

function DriverTipsSettings() {
    const [selectedTab, setSelectedTab] = useState('0');
    const [notification, setNotification] = useState({ text: '', level: '' });

    const handleChange = (event, value) => {
        setSelectedTab(value);
    };

    return (
        <Paper>
            <Notifications options={notification} />
            <Tabs onChange={handleChange} value={selectedTab} indicatorColor="primary" textColor="primary" centered>
                <Tab label="Driver Tips Settings" value="0" />
                <Tab label="Upload" value="1" />
            </Tabs>
            <TabPanel selectedTab={selectedTab} index="0">
                <ViewDriverTipsSettings setNotification={setNotification} />
            </TabPanel>
            <TabPanel selectedTab={selectedTab} index="1">
                <UploadDriverTipsSettings />
            </TabPanel>
        </Paper>
    );
}

export { DriverTipsSettings };
